import * as trackingApi from 'Tracking/tracking-api';
import { BE_GA_DEFAULT_PAYLOAD } from 'Views/booking/constants';
import { getTrackingRoomType } from 'Tracking/utils';
export function trackSelectRoom(accommodationsSet: AccommodationsSet, appContext: AppContext) {
  const roomType = getTrackingRoomType(accommodationsSet.accommodations);
  trackingApi.setDataLayer(
    {
      ...BE_GA_DEFAULT_PAYLOAD,
      versionBooking: 'responsive',
      actionGA: 'moreRooms',
      labelGA: `confirmRoom_${roomType}`,
    },
    appContext,
  );
}
